import React from 'react';
import { Alert, List, ListItem, ListItemText, Typography } from '@mui/material';

export default function ErrorList({ errors }) {
  return (
    <Alert severity="error" sx={{ display: 'flex', marginY: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Please correct the following errors:
      </Typography>
      <List sx={{ padding: 0, margin: 0, fontSize: 10 }}>
        {errors.map((error, index) => {
          if (error) {
            return (
              <ListItem key={`error_${index}`} sx={{ padding: 0 }}>
                <ListItemText
                  slotProps={{ primary: { fontSize: 12 } }}
                  primary={error}
                />
              </ListItem>
            );
          }
        })}
      </List>
    </Alert>
  );
}
